import { render, staticRenderFns } from "./VerificationID.vue?vue&type=template&id=5fac4cea&"
import script from "./VerificationID.vue?vue&type=script&lang=js&"
export * from "./VerificationID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports